import { Array, HashMap, pipe } from 'effect'
import { useCallback } from 'react'
import { atom, useSetRecoilState } from 'recoil'

export interface RowConfig {
  expanded: boolean
}

export const rowConfigsImplAtom = atom<HashMap.HashMap<string, RowConfig>>({
  key: `rsheet/rowConfig`,
  default: HashMap.empty(),
})

export type UpdateRowConfigsImplArgument = Array<{
  id: string
  value: RowConfig | undefined
}>

export const useUpdateRowConfigsImpl = (): ((updates: UpdateRowConfigsImplArgument) => void) => {
  const setRowConfigsImpl = useSetRecoilState(rowConfigsImplAtom)
  return useCallback(
    (updates: UpdateRowConfigsImplArgument) => {
      setRowConfigsImpl((previous) =>
        pipe(
          updates,
          Array.reduce(previous, (current, { id, value }) =>
            value === undefined ? HashMap.remove(current, id) : HashMap.set(current, id, value),
          ),
        ),
      )
    },
    [setRowConfigsImpl],
  )
}
